"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function AppRolesSelect(_ref) {
  var app = _ref.app,
    roles = _ref.roles,
    selected = _ref.selected,
    registerInner = _ref.registerInner;
  var appRoles = (0, _react.useMemo)(function () {
    return roles.filter(function (role) {
      var _a;
      return ((_a = role.apps) === null || _a === void 0 ? void 0 : _a.find(function (rApp) {
        return rApp.id === app.id;
      })) !== undefined;
    }).filter(function (role) {
      return role.id !== 'owner'; // https://focaltec.atlassian.net/browse/PPR-54
    });
  }, [roles, app]);
  var appSelected = (0, _react.useMemo)(function () {
    return selected.filter(function (el) {
      return appRoles.findIndex(function (appRole) {
        return appRole.id === el;
      }) >= 0;
    }).filter(function (el, i, arr) {
      return arr.indexOf(el) === i;
    });
  }, [selected, appRoles]);
  var rolesOptions = (0, _react.useMemo)(function () {
    return appRoles.map(function (role) {
      return {
        value: role.id,
        label: role.name
      };
    });
  }, [appRoles]);
  return /*#__PURE__*/_react["default"].createElement(_commons.AnyMultiselect, {
    name: "role_ids",
    label: (0, _core.translate)('roles.title'),
    initialValue: appSelected,
    options: rolesOptions,
    register: function register(name, ref) {
      return registerInner(app.id, name, ref);
    }
  });
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(AppRolesSelect);